<template>
  <div class="wrap">
    <img src="@/common/image/rotate/bg.png" alt="">
    <div class="top-nav">
      <div :class="{active: tabIndex === 0}" @click="tab(0)"><span>年会员</span></div>
      <div :class="{active: tabIndex === 1}" @click="tab(1)"><span>月会员</span></div>
    </div>
    <div class="tips">{{tips}}</div>
    <div class="pan">
      <div class="inner" :style="style"><div :style="panStyle"><!-- 转盘 --></div></div>
      <div class="arrow" @click="play"><!-- 箭头 --></div>
    </div>
    <div class="footer">
      <div class="panel clearfix">
        <div class="left" @click="showGiftList">我的奖品</div>
        <div class="right" @click="showRule">活动规则</div>
      </div>
      <div class="record">
        <img src="@/common/image/rotate/record.png" alt="">
        <div class="rect">
          <div class="list" v-if="otherList.length > 0" :style="'animation-duration: '+otherAnimationTime+'s'">
            <div class="item" v-for="(item, index) in otherList" :key="index">{{item}}</div>
          </div>
        </div>
      </div>
      <div class="gift">
        <div class="title">奖品</div>
        <div class="clearfix list">
          <dl v-for="(item, index) in giftList" :key="index">
            <dt><img :src="item.img" alt=""></dt>
            <dd>{{item.name}}</dd>
          </dl>
          <!-- <dl>
            <dt><img src="@/common/image/rotate/wp1.png" alt=""></dt>
            <dd>世达维修工具（价值169元）</dd>
          </dl>
          <dl>
            <dt><img src="@/common/image/rotate/wp2.png" alt=""></dt>
            <dd>京东E卡（50元）</dd>
          </dl>
          <dl>
            <dt><img src="@/common/image/rotate/wp3.png" alt=""></dt>
            <dd>维修工具（价值15元）</dd>
          </dl>
          <dl>
            <dt><img src="@/common/image/rotate/wp4.png" alt=""></dt>
            <dd>golo维修课堂积分</dd>
          </dl> -->
        </div>
        <div class="spec">图片仅为展示，具体以实物为准</div>
      </div>
    </div>
    <!-- 抽中弹窗 -->
    <div class="popup" v-if="showGiftPopup">
      <div class="mask"></div>
      <div class="get-gift">
        <img src="@/common/image/rotate/gift-bg.png" alt="">
        <div class="name">{{giftName}}</div>
        <div class="btn" @click="seeGift"><!-- 按钮 --></div>
      </div>
    </div>
    <!-- 我的奖励 -->
    <div class="popup" v-if="showGiftListPopup">
      <div class="mask"></div>
      <div class="con my-gift">
        <div class="title">我的奖励</div>
        <div class="list" v-if="myGiftList.length">
          <div class="item border-bottom" v-for="(item, index) in myGiftList" :key="index">
            <div class="name">{{item.prize_name}}</div>
            <div class="time">{{item.createtime}}</div>
          </div>
        </div>
        <div class="no-data" v-if="myGiftList.length === 0">暂无数据</div>
        <img src="@/common/image/rotate/close.png" alt="" class="close" @click="showGiftList(false)">
      </div>
    </div>
    <!-- 活动规则 -->
    <div class="popup" v-if="showRulePopup">
      <div class="mask"></div>
      <div class="con rule">
        <div class="title">活动规则</div>
        <div class="line">活动时间：每月12日—14日</div>
        <div class="line">参与条件：会员期限内的所有会员</div>
        <div class="title">参与规则</div>
        <div class="line">1.活动期间，会员可参与对应的抽奖环节；</div>
        <div class="line">2.活动期间，年卡会员有2次抽奖机会，分别为年卡专属转盘和月卡转盘；</div>
        <div class="line">3.活动期间开通会员权限，可以立即参与本月抽奖</div>
        <div class="line">4.奖品将通过推送消息，golo维修课堂客服添加微信，送出；</div>
        <div class="line">5.请获奖的会员留意golo汽修大师微信公众号推送；</div>
        <div class="line">6.本活动最终解释权由golo维修课堂持有；</div>
        <img src="@/common/image/rotate/close.png" alt="" class="close" @click="showRule(false)">
      </div>
    </div>
    <!-- 提示去绑定手机号 -->
    <div class="popup" v-if="showBindPhone">
      <div class="mask" @click="showBindPhone=false"></div>
      <div class="bind-body">
        <div class="msg">参与抽奖活动需要先绑定手机号码</div>
        <router-link tag="div" class="btn border-top" to="/personal/bindphone">立即绑定</router-link>
      </div>
    </div>
    <!-- 提示购买会员才能玩游戏 -->
    <div class="popup" v-if="showBuyVip">
      <div class="mask" @click="showBuyVip=false"></div>
      <div class="bind-body">
        <div class="msg">开通会员可参与抽奖</div>
        <router-link tag="div" class="btn border-top" to="/vip">去开通</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import base from './base'
import {giftList, panList} from './config'
import {random, getActivityInfo, draw, getMyGift, getOtherList} from '@/api/activity/rotate'
import {rotateShare} from '@/api/wx-share.js'
import {mapGetters} from 'vuex'
export default {
  mixins: [base],
  data() {
    return {
      giftName: '',
      showGiftPopup: false,
      myGiftList: [],
      showGiftListPopup: false,
      showRulePopup: false,
      // 绑定手机提示弹窗
      showBindPhone: false,
      // 购买会员提示弹窗
      showBuyVip: false,
      // 活动信息
      info: {},
      // 当前tab
      tabIndex: 0,
      // 其他人中奖列表
      otherList: [],
      otherAnimationTime: 0,
      running: false
    }
  },
  computed: {
    giftList() {
      // 底部礼物列表
      return giftList[this.tabIndex]
    },
    panStyle() {
      // 转盘的背景图
      return 'background-image: url(' + panList[this.tabIndex] + ')'
    },
    times() {
      // 当前 tab（年会员还是月会员） 下的剩余抽奖次数
      return this.info[['remain_times_year', 'remain_times_month'][this.tabIndex]]
    },
    tips() {
      // 机会提示
      return this.times ? '您有一次抽奖机会!' : this.info.user_member_type === 0 ? '暂无抽奖机会' : '抽奖机会已用完'
    },
    ...mapGetters(['user'])
  },
  created() {
    getActivityInfo().then(data => {
      if (data) {
        this.info = data
        // 初始化tab
        if (this.info.user_member_type === 1) {
          // 年会员
          this.tabIndex = 0
        } else if (this.info.user_member_type === 2) {
          // 月会员
          this.tabIndex = 1
        }
      }
    })
    getOtherList().then(data => {
      if (data) {
        this.otherList = data
        this.otherAnimationTime = 0.3 * data.join('').length
      }
    })
  },
  mounted() {
    // 分享配置
    rotateShare()
  },
  methods: {
    showGift(giftName) {
      this.giftName = giftName
      this.showGiftPopup = true
    },
    showGiftList(f = true) {
      getMyGift().then(data => {
        if (data && data.length) {
          this.myGiftList = data
        }
      })
      this.showGiftListPopup = f
    },
    showRule(f = true) {
      this.showRulePopup = f
    },
    seeGift() {
      // 查看奖励
      this.giftName = ''
      this.showGiftPopup = false
      this.showGiftList()
    },
    tab(type) {
      // 判断当前用户会员的类型
      // if (type === 0) {
      //   // 年会员
      //   if (this.info.user_member_type !== 1) {
      //     this.$toast('赶快去充值成为年会员吧！')
      //     return
      //   }
      // } else if (type === 1) {
      //   // 月会员
      //   if (this.info.user_member_type === 0) {
      //     this.$toast('赶快去充值成为月会员吧！')
      //     return
      //   }
      // }
      this.tabIndex = type
      this.reset()
    },
    play() {
      // 开始玩游戏
      // if (!this.user.mobile) {
      // this.showBindPhone = true
      // return
      // }
      // 转盘重置
      if (!this.running) {
        this.reset()
      }
      // 判断活动状态
      // 0活动未开始；1、活动进行中；2、活动已结束 3、活动当天未开始；4、活动当天已结束
      const status = this.info.is_activity_status
      if (!status) {
        this.$toast('活动未开始')
        return
      } else if (status === 2) {
        this.$toast('活动已结束')
        return
      } else if (status === 3) {
        this.$toast('活动将于今天' + this.info.daystart + '开始')
        return
      } else if (status === 4) {
        this.$toast('今天活动已结束')
        return
      }
      // 判断用户vip类型
      const type = this.tabIndex
      if (type === 0) {
        // 年会员
        if (this.info.user_member_type !== 1) {
          // this.$toast('赶快去充值成为年会员吧！')
          this.showBuyVip = true
          return
        }
      } else if (type === 1) {
        // 月会员
        if (this.info.user_member_type === 0) {
          // this.$toast('赶快去充值成为月会员吧！')
          this.showBuyVip = true
          return
        }
      }
      // 判断次数
      if (!this.times) {
        this.$toast(this.tips)
        return
      }
      if (!this.running) {
        this.running = true
        // 转动转盘
        this.start()
        // tabIndex 0 是年费 1 月卡, 接口参数 1是年费 2是月卡
        draw(this.tabIndex + 1).then(data => {
          console.log(data)
          if (data) {
            // 修改剩余次数，目前活动只有一次机会抽奖，所以直接改成 0
            this.info[['remain_times_year', 'remain_times_month'][this.tabIndex]] = 0
            // 转换索引
            this.afterDraw(Number(data.id) - 1, () => {
              // 延时显示中奖弹窗
              setTimeout(() => {
                this.showGift(data.prize_name)
                this.running = false
              }, 1200)
            })
          }
        }).catch(() => {
          this.running = false
          this.reset()
        })
      }
    },
    afterDraw(giftIndex, cb) {
      // giftIndex 中了哪个奖品
      const gift = giftList[this.tabIndex][giftIndex]
      if (gift) {
        // 拿到扇区
        const sectors = gift.sectors
        // debugger
        if (sectors) {
          let deg = 0
          if (sectors.length > 1) {
            deg = sectors[random(sectors.length)] * 60
          } else {
            deg = sectors[0] * 60
          }
          // 再加个随机位置
          const s = (random(50) - 25)
          this.stop(360 - deg + s, cb)
        }
      }
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  $h = 1714;
  $w = 750;
  p($num, $y)
    percentage($num / $y)
  ph($num)
    p($num, $w)
  pv($num)
    p($num, $h)
  h-mid()
    left 50%
    transform translateX(-50%)
  v-mid()
    top 50%
    transform translateY(-50%)
  mid()
    left 50%
    top 50%
    transform translate(-50%, -50%)
  bg($url)
    background-image url($url)
    background-size 100% 100%
  img{
    display: block;
    width: 100%;
  }
  .wrap{
    position relative;
    // overflow hidden;
    background #33009d;
    min-height size(1600);
  }
  .top-nav{
    position: absolute
    width: ph(356)
    // height pv(68)
    height size(68)
    line-height size(68)
    h-mid()
    top pv(250)
    display flex
    align-items center
    // border-radius size(46)
    font-size size(28)
    color #111
    >div{
      flex 1
      text-align center
      height 100%
      position relative
      // border-radius size(46)
      // background-image linear-gradient(to right, #fee94e 0%, #fcce26 100%)
      background-color #EAB903;
      color: #C97E20;
      &:first-child{
        border-top-left-radius: size(46);
        border-bottom-left-radius: size(46);
      }
      &:last-child{
        border-top-right-radius: size(46);
        border-bottom-right-radius: size(46);
      }
      &.active{
        z-index 1
        box-shadow 0px 2px 14px 4px #08dcf7
        color #fff
        background-image linear-gradient(180deg, #ff3df2 0%, #d85ecc 100%)
      }
    }
  }
  .tips{
    position absolute
    h-mid()
    top pv(346)
    min-width ph(284)
    height size(48)
    line-height size(48)
    text-align center
    padding 0 size(12)
    border-radius 8px
    background-color: rgba(39, 39, 39, 0.64)
    font-size size(24)
    color #fff
    letter-spacing: 2.5px;
  }
  .pan{
    position absolute
    h-mid()
    top pv(418)
    width ph(635)
    height pv(635)
    bg('~@/common/image/rotate/pan-bg.png')
    .inner{
      position absolute
      width p(524, 635)
      height p(524, 635)
      // mid()
      left p((635 - 524) / 2, 635)
      top p((635 - 524) / 2, 635)
      >div{
        width 100%
        height 100%
        background-size 100% 100%
        // 不同会员有不同转盘 背景图只能放在js了
        // bg('~@/common/image/rotate/pan-inner.png')
      }
    }
    .arrow{
      position absolute
      width p(248, 635)
      height p(248, 635)
      mid()
      bg('~@/common/image/rotate/arrow.png')
    }
  }
  .footer{
    position absolute
    left 0
    width 100%
    top pv(1056)
    .panel{
      color #fff
      font-size size(26)
      line-height 1.4
      .left{
        float left
        padding 0 size(56)
      }
      .right{
        float right
        padding 0 size(56)
      }
    }
    .record{
      margin-top size(12)
      position relative
      color: #99f8ff;
      letter-spacing: 6px;
      font-size size(26)
      .rect{
        width ph(650)
        position absolute
        overflow hidden
        mid()
        top 45%
        height size(40)
      }
      .list{
        position absolute
        left 0
        top 0
        font-size 0
        white-space nowrap
        animation toleft 40s linear infinite;
        @keyframes toleft {
          from{
            transform: translateX(0%);
          }
          to{
            transform: translateX(-100%);
          }
        }
        width auto
      }
      .item{
        margin-right size(32)
        display inline-block
        font-size size(26)
      }
    }
  }
  .gift{
    margin size(10) size(48) 0
    background-color: rgba(71, 71, 71, 0.2);
    box-shadow: 0px 0px 6px 1px #cddee0;
    border-radius: 6px;
    border:1px solid  #b3f8ff;
    color #fff
    .title{
      font-size size(26)
      color #99f8ff
      text-align center
      padding size(22) 0
    }
    .list{
      padding 0 size(10)
      dl{
        float left
        width 25%
        text-align center
        padding: 0 size(6);
      }
      dd{
        margin-top size(10)
        font-size size(22)
        line-height size(30)
      }
    }
    .spec{
      text-align center
      font-size size(24)
      padding size(15) 0
      margin-top size(6)
    }
  }
  .popup{
    .mask{
      position fixed
      background rgba(0,0,0,0.64)
      left 0
      bottom 0
      right 0
      top 0
      z-index 1
    }
    .con{
      position fixed
      mid()
      width ph(608)
      z-index 2
      color #fff
      background-color: rgba(54, 14, 139, 0.9);
      box-shadow: 0px 0px 6px 1px #cddee0;
      border-radius: 6px;
      border: 1px solid  #b3f8ff;
      min-height size(610)
      .close{
        position absolute
        h-mid()
        width size(60)
        bottom size(-110)
      }
      padding size(24) size(54)
      color #e4e2e2
    }
    .title{
      font-size size(30)
      color: #b3f8ff;
      padding size(24) 0;
    }
  }
  .my-gift{
    .list{
      height size(430)
      overflow-y scroll
    }
    .item{
      padding size(22) 0
      .name{
        font-size size(28)
      }
      .time{
        font-size size(26)
        color #a2a2a2
        margin-top size(16)
      }
    }
    .no-data{
      font-size size(24)
      text-align center
      color #a2a2a2
    }
  }
  .rule{
    .line{
      line-height size(40)
      font-size size(28)
      margin size(9) 0
    }
  }
  .get-gift{
    position fixed
    left 0
    width 100%
    v-mid()
    top 34%
    z-index 9
    .name{
      position absolute
      left 0
      width 100%
      text-align center
      font-size size(40)
      color #fff
      bottom p(124, 876)
    }
    .btn{
      position absolute
      h-mid()
      width p(356, 750)
      // background gold
      height p(88, 876)
      bottom 0
    }
  }
  .bind-body{
    position fixed
    mid()
    z-index 9
    background #fff
    width 75%
    text-align center
    border-radius 4px
    .msg{
      padding size(90) size(30)
      font-size size(30)
    }
    .btn{
      line-height size(90)
      font-size size(28)
      color $color-theme
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/activity/rotate/index.vue